import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../../../../../services/account.service';

@Component({
  selector: 'app-merchantid-dialog',
  templateUrl: './merchantid-dialog.component.html',
  styleUrls: ['./merchantid-dialog.component.css']
})
export class MerchantidDialogComponent implements OnInit {
  title: string;
  razorpay_merchantId: any;
  razorpay_merchantkey: any;
  razorpay_webhookKey: any;
  webhookKey: any;
  paymentMode: any;
  api_success: string;
  api_error: any;
  payU_placeholder = 'Enter MerchantId';
  payUTextVal = 'Set';
  razorPayTextVal='Set';
  merchantId: any;
  disableConfirmbtn = false;
  merchantKey: string;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, private accountService: AccountService) { }

  ngOnInit() {
    if (this.data.paymentDetails.payUMerchantId) {
      this.payUTextVal = 'Reset';
      this.payU_placeholder = this.data.paymentDetails.payUMerchantId;
    }
    if(this.data.paymentDetails.razorpayMerchantId){
  
      this.razorpay_merchantId=this.data.paymentDetails.razorpayMerchantId;
      this.razorpay_merchantkey=this.data.paymentDetails.razorpayMerchantKey;
      this.razorpay_webhookKey=this.data.paymentDetails.razorpayWebhookMerchantKey;
      this.razorPayTextVal='Reset';

    }
    this.paymentMode = this.data.paymentMode;
    if(this.paymentMode==='razorPay'){
      this.title = this.razorPayTextVal.toUpperCase() + " Merchant Details";

    }else {
      this.title = this.payUTextVal.toUpperCase() +" Merchant Details";
    }

  }

  setMerchantId() {
    console.log(this.paymentMode);
    if (this.paymentMode === 'razorPay') {
      console.log('inside razorPay');
      this.razorPaySettings();
    } else {
      this.api_error = '';
      this.api_success = '';
      this.disableConfirmbtn = true;
      const data = {
        'accountId': this.data.accountId,
        'payUmerchantid': this.merchantId

      };
      this.accountService.setmerchantId(data)
        .subscribe(res => {
          this.api_success = 'MerchantId ' + this.payUTextVal + ' successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.disableConfirmbtn = false;
          });

    }
  }


  razorPaySettings() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    const data = {
      'accountId': this.data.accountId,
      'merchantId': this.merchantId,
      'merchantKey': this.merchantKey,
      'webHookId':this.webhookKey

    };
 
    this.accountService.setRazorpayMerchantDetails(data)
      .subscribe(res => {
        console.log(res);
        this.api_success = 'Merchant Id and Key ' + this.razorPayTextVal + ' successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.disableConfirmbtn = false;
        });

  }
}
